import * as React from 'react';

export interface WhenProps {
  condition: boolean | (() => boolean);
  children: React.ReactNode | Function;
}

function When({children}: WhenProps) {
  if (typeof children === 'function') {
    return children();
  }
  return children;
}

export default When;
